module.exports = __webpack_public_path__ + "img/F003_R_home slider.d213ee2c.jpg";